import * as React from "react";

import ComponentPage from "../../Components/ComponentPage";
import Usage from "../../Docs/Components/List/ListUsage.mdx";

import Examples from "../../Docs/Components/List/ListExamples";
        
class Page extends React.Component {
public render() {
    return (
        <ComponentPage
            name="List"
            description="A list displays a group of selectable, actionable items."
            apiSources={["azure-devops-ui/Components/List/List.Props.d.ts"]}
            examples={Examples}
            status={{"design":"done","code":"done","docs":"Planned (Q3)"}}
            usage={Usage}
        />
    );
}
}
        
export default Page;